
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/desarrollos/thankyoupage-agenda-cita",
      function () {
        return require("private-next-pages/desarrollos/thankyoupage-agenda-cita.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/desarrollos/thankyoupage-agenda-cita"])
      });
    }
  